import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { RegularExpressions } from "../../../Helpers/RegularExpression";
import { ValFormReg } from "../../../Validators/ValForms";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import WarningIcon from "@mui/icons-material/Warning";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import request from "../../../Helpers/API";
import { TextField } from "@mui/material";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import InfoIcon from "@mui/icons-material/Info";
import { GetDocumentpo } from "../../../Helpers/GetDocumento";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";


export const ValidarReporteCampo = ({
  folio,
  setLoader,
  loader,
  updateComentarios,
  idproceso = 19,
  // Inyectado por ModalSolicitudCreditoJDF (ver ModalSCScreens). Habilita
  // "Siguiente" tras aceptar, sin cerrar el modal.
  habilitarSiguiente,
}) => {
  const [comentarios, setComentarios] = useState("");
  const [documento, setDocumento] = useState({
    documento: "",
    extension: "",
  });
  const [estatus, setEstatus] = useState({});




  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: idproceso,
      iddocumento: 66,
      responsable: "J",
    };
    request
      .post(`ACJDF_DecicionUnDocumento`, post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  }, []);
  const onEnviarComentario = (estado) => {
    // const rescomentarios = ValFormReg(
    //   "Comentarios",
    //   comentarios,
    //   RegularExpressions.TextSpecialCharacter,
    //   15,
    //   2000
    // );
    // if (rescomentarios.isValid === false) {
    //   Swal.fire(
    //     "ANALISIS DE SOLICITUD DE CREDITO",
    //     rescomentarios.mensaje,
    //     "error"
    //   );
    //   return;
    // }
    if (
      documento.documento === undefined ||
      documento.documento === null ||
      documento.documento === ""
    ) {
      Swal.fire(
        "ANALISIS DE SOLICITUD DE CREDITO",
        "El documento digital del reporte de campo es obligatorio",
        "error"
      );
      return;
    }
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: idproceso,
      iddocumento: 66,
      documento: documento.documento,
      extension: documento.extension,
      comentarios:
        comentarios.length === 0 ? "REPORTE DE CAMPO VALIDADO" : comentarios,
      estatus: estado,
    };
    request
      .post("ACJDF_Comentarios_UnDocumento_Guardar", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result.documentacion);

        setComentarios("");
        if (updateComentarios !== undefined && updateComentarios !== null)
          updateComentarios();

        // Habilita "Siguiente" sin recargar data/estado ni cerrar el modal.
        if (
          estado === "A" &&
          habilitarSiguiente !== undefined &&
          habilitarSiguiente !== null
        )
          habilitarSiguiente();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const OnGetIcon = ({ icon }) => {
    switch (icon) {
      case "wait":
        return <PendingIcon />;
      case "success":
        return <CheckCircleIcon />;
      case "warning":
        return <WarningIcon />;
      case "error":
        return <ErrorIcon />;
      default:
        <></>;
    }
  };
  const onChange = (prop, value, sbool, smensaje) => {
    setComentarios(value);
  };
  const onImprimirArchivo = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerDocumento?folio=${folio}&iddocumento=${Number(
          66
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = result.comentarios;
        const downloadLink = document.createElement("a");
        const fileName = `${result.documento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE SOLICITUD DE CREDITO", error.mensaje, "error");
      });
  };
  return (
    <div className="analisis-credito-modal-comentarios-jdf">
      <div className="analisis-credito-modal-comentarios-jdf-content">
        <div className="analisis-credito-modal-comentarios-jdf-content-title">
          <InfoIcon className="icon-info" /> TIEMPO DE RESPUESTA ESTIMADO:{" "}
          {estatus.tiempoestimado}
        </div>
        <div className="analisis-credito-modal-jdf-content-comentarios">
          {estatus.habilitar === undefined ||
            estatus.habilitar === null ||
            estatus.habilitar === false ? (
            <></>
          ) : (
            <>
              <TextField
                fullWidth
                size="small"
                label="COMENTARIOS"
                className="cel-1 analisis-credito-modal-jdf-content-comentarios-text"
                multiline
                rows={4}
                type="text"
                onChange={({ target }) => {
                  ValSpecialCharacters(
                    "condiciones",
                    target.value,
                    onChange,
                    true,
                    500
                  );
                }}
                value={comentarios}
              />
              <div>
                <TextField
                  fullWidth
                  type="file"
                  onChange={({ target }) => GetDocumentpo(target, setDocumento)}
                  sx={{ mt: 2 }}
                />
              </div>
              <div className="analisis-credito-modal-jdf-content-buttons">
                <div
                  className="analisis-credito-modal-pedido-content-cancel-button"
                  onClick={() => {
                    onEnviarComentario("R");
                  }}
                >
                  <CancelIcon />
                  <div>RECHAZAR</div>
                </div>
                <div
                  className="analisis-credito-modal-pedido-content-acept-button"
                  onClick={() => {
                    onEnviarComentario("A");
                  }}
                >
                  <CheckCircleIcon />
                  <div>ACEPTAR</div>
                </div>
              </div>
            </>
          )}
        </div>
        {estatus.habilitar === undefined ||
          estatus.habilitar === null ||
          (estatus.habilitar === false && (
            <>
              <div
                className={`analisis-credito-modal-pedido-content-comentarios analisis-credito-modal-pedido-content-comentarios-${estatus.icono}`}
              >
                <label>Comentarios</label>
                <div className="analisis-credito-modal-pedido-content-comentarios-svg">
                  <OnGetIcon icon={estatus.icono} />
                </div>
                <div className="analisis-credito-modal-pedido-content-comentarios-div">
                  {estatus.comentarios}
                </div>
              </div>
              {estatus.documento !== undefined &&
                estatus.documento !== null &&
                estatus.documento !== false && (
                  <div
                    className="analisis-credito-modal-pedido-content-pdf"
                    onClick={() => onImprimirArchivo()}
                  >
                    <CloudDownloadIcon />
                    <div>DESCARGAR REPORTE DE CAMPO</div>
                  </div>
                )}
            </>
          ))}
      </div>
      <div className="analisis-credito-modal-pedido-footer"></div>
    </div>
  );
};
